import { FC, memo } from 'react';

import { H2 } from '../../components/heading/Hx';
import Paragraph from '../../components/paragraph/Paragraph';
import Route from '../../components/route/Route';
import { RoutePath } from '../../components/route/type';
import Section from '../../components/section/Section';
import Video from '../../components/video/Video';
import { COLOR } from '../../theme/type';

const Beschreibung: FC = () => (
  <Section background={COLOR.Dark3}>
    <H2 color={COLOR.Gold1}>Kampfkunst, Selbstverteidigung, Selbst-Optimierung</H2>
    <Paragraph>
      Systema "<Route href={RoutePath.SolovevStyle}>Solovev Defense</Route>" ist
      Charakter-Entwicklung und{' '}
      <Route href={RoutePath.Selbstverteidigung}>Selbstverteidigung</Route> mit einzigartiger{' '}
      <Route href={RoutePath.KampfkunstRanking}>Methodik</Route>. Das Training hilft dabei,
      effektiver und effizienter zu werden. Weil alle Übungen frei sind, arbeiten alle Teilnehmer
      zusätzlich an ihrer Kreativität und lernen, für alle Probleme Lösungen zu finden.
    </Paragraph>
    <Video src={'272246677'} />
  </Section>
);

export default memo(Beschreibung);
